import Vue from 'vue'
import Router from 'vue-router'
import App from './App'
import DnsTalk from './slideshows/dns-talk/DnsTalk'

import Eagle, { Options } from 'eagle.js'
import 'eagle.js/dist/eagle.css'
import hljs from 'highlight.js'

/* eslint-disable no-new */

Vue.use(Eagle)
Vue.use(Router)
Vue.config.productionTip = false
Options.hljs = hljs

const router = new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      component: DnsTalk
    }
  ]
})

new Vue({
  el: '#app',
  router,
  render: h => h('App'),
  components: { App }
})
